import axios from 'axios'
import { useState } from 'react'
import authService from '../../../../Components/Login/auth.service'
import '../../../../styles/pages/SubMenuPages/SubMenuTipoDeObservacao/modal-tiposDeobservacoes/modalNovoGrupoDeQuestoes.css'

export default function Modal({ setOpenModal, modalInfo }) {
    var user = authService.getCurrentUser()
    let newDate = new Date()
    const [campos, setCampos] = useState({
        IdObservacaoSubGrupo: modalInfo.IdObservacaoSubGrupo,
        IdObservacaoGrupo: modalInfo.IdObservacaoGrupo,
        IdObservacaoTipo: modalInfo.IdObservacaoTipo,
        IdEmpresa: modalInfo.IdEmpresa,
        sbgNumero: modalInfo.sbgNumero,
        sbgDescricao: modalInfo.sbgDescricao,
        sbgStatus: modalInfo.sbgStatus,
        sbgObservacoes: modalInfo.sbgObservacoes,
        sbgAlteradoPor: user[0].pesEmail,
        sbgAlteradoEm: newDate
    })
    function handleInputChange(event) {
        if (event.target.name === 'sbgStatus') {
            if (event.target.checked) {
                campos[event.target.name] = 1
            } else {
                campos[event.target.name] = 0
            }
        } else {
            campos[event.target.name] = event.target.value
        }
        setCampos(campos)
    }

    function handleFormSubmit(event) {
        event.preventDefault()
        console.log('Campos:', campos) // Adicione esta linha para depuração
        //return;
        axios
            .post(
                process.env.REACT_APP_API_URL +
                '/api/v1/observacaosubgrupo/' +
                modalInfo.IdObservacaoSubGrupo,
                campos
            )
            .then(response => {
                if (response.status === 200) {
                    alert(response.data.message)
                    window.location.reload()
                } else {
                    alert(response.data.message)
                }
            })
    }

    return (
        <>
            <div className="overlay">
                <div className="modalPadrao-content">
                    <div className="cxTituloPadrao">
                        <h1>
                            Editar Sub Grupo De Questões
                            <hr className="hrTitleModal" />
                        </h1>
                        <button className="close-modal" onClick={() => setOpenModal(false)}>
                            X
                        </button>
                    </div>
                    <form onSubmit={handleFormSubmit}>
                        <div className="linhaTipObs" style={{ width: '100%' }}>
                            <tr>
                                <th><label>Ordem</label></th>
                                <th><label>Descrição:</label></th>
                            </tr>
                            <tr>
                                <td>
                                    <input
                                        type="number"
                                        id="sbgNumero"
                                        name="sbgNumero"
                                        min={1}
                                        required
                                        onChange={handleInputChange}
                                        defaultValue={campos.sbgNumero}
                                    ></input>
                                </td>
                                <td style={{ width: 780 }}>
                                    <input
                                        type="text"
                                        id="sbgDescricao"
                                        name="sbgDescricao"
                                        required
                                        onChange={handleInputChange}
                                        defaultValue={campos.sbgDescricao}
                                    ></input>
                                </td>
                            </tr>
                        </div>

                        <label>
                            Observações:
                        </label>
                        <textarea
                            type="text"
                            id="sbgObservacoes"
                            name="sbgObservacoes"
                            row="none"
                            maxLength="500"
                            onChange={handleInputChange}
                            defaultValue={campos.sbgObservacoes}
                        ></textarea>
                        <div className="caixaSalvarPadrao">
                            <div className="InputAuthorization1">
                                <label>
                                    <input
                                        name="sbgStatus"
                                        type="checkbox"
                                        onChange={handleInputChange}
                                        defaultChecked={!!campos.sbgStatus} />
                                    <span style={{ position: 'relative' }}>
                                        Status do Registro
                                    </span>
                                </label>
                            </div>
                            <button typeof="submit">
                                Salvar Grupo
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}